import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

interface Props {
  crumbs: Crumb[];
  title: string;
  desc?: string;
  children?: ReactNode;
}

export default function PageHeader({ crumbs, title, desc, children }: Props) {
  return (
    <section className="relative overflow-hidden bg-background-100 pt-24 md:pt-28">
      <div className="absolute -right-16 -top-16 h-56 w-56 rounded-full bg-primary-100/70 blur-3xl" />
      <div className="absolute -left-10 bottom-0 h-40 w-40 rounded-full bg-accent-100/70 blur-3xl" />
      <div className="relative z-10 mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <nav aria-label="面包屑导航" className="mb-4">
          <ol className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-500">
            {crumbs.map((c, i) => (
              <li key={c.label} className="flex items-center gap-1.5">
                {c.to ? (
                  <Link to={c.to} className="hover:text-primary-600">{c.label}</Link>
                ) : (
                  <span className="text-foreground-700">{c.label}</span>
                )}
                {i < crumbs.length - 1 && <i className="ri-arrow-right-s-line" />}
              </li>
            ))}
          </ol>
        </nav>
        <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">{title}</h1>
        {desc && <p className="mt-3 max-w-2xl text-sm text-foreground-600 md:text-base">{desc}</p>}
        {children}
      </div>
    </section>
  );
}